// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__13r-v","legacyBtn":"MutateMid_legacyBtn__3sL_j"};